import styles from './SplitBar.module.css';

/**
 * THE signature component: the win-probability split bar.
 *
 * Two sides, the split between them, and the predicted winner's side glowing in
 * the accent gradient. Everything else in the product is built around this.
 *
 * homeProbability: 0-100, the left side's win probability. The right side is
 *                  rendered as the remainder, so the two always sum to 100.
 * winner:          'home' | 'away' — which side gets the accent glow.
 * size:            'sm' (compact list row) | 'md' (default) | 'lg' (result card)
 *
 * Percentages are rounded for display only; pass the raw number from the API.
 */
export function SplitBar({
  homeProbability,
  winner = 'home',
  size = 'md',
  homeLabel,
  awayLabel,
  className = '',
}) {
  // Clamp so a bad number from upstream can never break the layout.
  const home = Math.max(0, Math.min(100, Number(homeProbability) || 0));
  const away = 100 - home;

  // Keep both numbers legible even on a lopsided 92/8 split.
  const homeWidth = Math.max(18, Math.min(82, home));

  return (
    <div
      className={`${styles.splitbar} ${styles[size]} ${className}`}
      role="img"
      aria-label={`Win probability: ${homeLabel || 'home'} ${Math.round(home)} percent, ${
        awayLabel || 'away'
      } ${Math.round(away)} percent`}
    >
      <div
        className={`${styles.side} ${styles.a} ${winner === 'home' ? styles.win : ''}`}
        style={{ width: `${homeWidth}%` }}
      >
        {Math.round(home)}%
      </div>
      <div
        className={`${styles.side} ${styles.b} ${winner === 'away' ? styles.win : ''}`}
        style={{ width: `${100 - homeWidth}%` }}
      >
        {Math.round(away)}%
      </div>
    </div>
  );
}
